import styled from 'styled-components';

export const Send = styled.button`
	color: #fff;

	text-align: center;
	font-family: Work Sans;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: 0.8px;
	text-transform: uppercase;
	padding: 17px 74px 14px 75px;
	border-radius: 100px;
	background: var(--Purple, linear-gradient(10deg, #48068a 10%, #4322c6 65%));
	cursor: pointer;
	@media (max-width: 600px) {
		width: 200px;
		padding: 15px 35px 15px 35px;
	}
`;

export const Skip = styled.button`
	color: #29185e;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 140%; /* 19.6px */
	text-decoration-line: underline;
	background-color: white;

	cursor: pointer;
`;

export const P = styled.p`
	color: #29185e;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 140%; /* 19.6px */
	margin: 0;
	margin-top: 50px;
	margin-bottom: 18px;
`;

export const TitlePopUp = styled.h2`
	color: #29185e;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 20px;
	font-style: normal;
	font-weight: 700;
	line-height: 140%; /* 28px */
	margin: 0;

	@media (max-width: 600px) {
		max-width: 280px;
	}
`;

export const SubTitlePopUp = styled.h3`
	color: #29185e;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 140%; /* 19.6px */
	margin: 0;
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	justify-content: space-evenly;
	margin-top: 50px;

	@media (max-width: 600px) {
		flex-direction: column;
		align-items: center;
		margin-top: 20px;
	}
`;

export const TextArea = styled.textarea`
	width: 700px;
	height: 92px;
	padding: 16px 18px;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
	border-radius: 8px;
	background: #eef2f5;
	outline: none;
	border: none;
	resize: none;

	color: #05275d;

	font-family: Lato;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 123.5%;

	@media (max-width: 600px) {
		width: 300px;
		height: 140px;
		padding: 5px;
	}
`;

export const LetterCounterWrapper = styled.p`
	text-align: right;
	color: #868686;
	font-family: Work Sans;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 140%;
	margin: 0;

	@media (max-width: 600px) {
		width: 100%;
		justify-content: right;
	}
`;

export const PopUpWrapper = styled.form`
	padding: 50px;

	@media (max-width: 600px) {
		padding: 10px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
`;
